/**
 * The texels of an image cut into layers, as Godot's layered importer cuts it for a 3D texture or
 * a texture array (`editor/import/resource_importer_layered_texture.cpp:370-386`). It reads
 * decoded pixels, so a test runs it without a browser.
 */
import { emptyLike, isPlainPixels } from '../../utils/emptyLike';
/**
 * Each layer is the image's size over the counts, truncated, so a remainder column or row is
 * dropped. Layers run left to right, then top to bottom. Null when a layer is empty, which Godot
 * skips (`:380`), leaving no texture. The texels can share the image's buffer. Half-float bits
 * stay half-float bits, and bytes land in a plain `Uint8Array`.
 */
export function sliceImage(image, { horizontal, vertical }) {
    const width = Math.trunc(image.width / horizontal);
    const height = Math.trunc(image.height / vertical);
    if (width < 1 || height < 1)
        return null;
    const depth = horizontal * vertical;
    if (horizontal === 1 && height * vertical === image.height && isPlainPixels(image.data)) {
        return { texels: image.data, width, height, depth };
    }
    const length = width * height * depth * 4;
    const texels = emptyLike(image.data, length);
    const rowTexels = width * 4;
    for (let layer = 0; layer < depth; layer++) {
        const left = (layer % horizontal) * width;
        const top = Math.trunc(layer / horizontal) * height;
        for (let y = 0; y < height; y++) {
            const source = ((top + y) * image.width + left) * 4;
            texels.set(image.data.subarray(source, source + rowTexels), (layer * height + y) * rowTexels);
        }
    }
    return { texels, width, height, depth };
}
/**
 * The layers cut down to their red byte, one byte for each texel: all a shadowmask reads, so its
 * texture takes a quarter of the memory.
 */
export function redOnly({ texels, ...size }) {
    const red = new Uint8Array(texels.length / 4);
    for (let texel = 0; texel < red.length; texel++)
        red[texel] = texels[texel * 4];
    return { texels: red, ...size };
}
//# sourceMappingURL=layeredTexels.js.map